<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/WorkEnvSurvey/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>